import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getSessionId() {
  let sid = localStorage.getItem("visitor_session");
  if (!sid) {
    sid = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("visitor_session", sid);
  }
  return sid;
}

export function track(eventType, data = {}) {
  try {
    axios.post(`${API}/track`, {
      session_id: getSessionId(),
      event_type: eventType,
      referrer: document.referrer || null,
      ...data,
    }).catch(() => {});
  } catch {
    /* best-effort, never block UI */
  }
}
